<template>
  <div class="bg-nosotros-2">
    <el-row :gutter="20"
      ><h1 class="titulo_calidad">/{{ $t('calidad.titulo') }}</h1>
      <el-col :md="8" :xs="24" class="grande-col">
        <!-- <div class="card-wrapper"> -->
        <el-card class="box-card">
          <div slot="header" class="clearfix subtitulo_calidad">
            <span
              ><center>{{ $t('calidad.habilitaciones.titulo') }}</center></span
            >
          </div>

          <el-carousel indicator-position="outside" sty>
            <el-carousel-item v-for="(img, i) in images" :key="i" class="carousel-slide" style="background-color: white !important">
              <img class="foto" style="display: flex; align-items: center" :src="img" alt="foto" />
            </el-carousel-item>
          </el-carousel>
        </el-card>
        <!-- </div> -->
      </el-col>
      <el-col :md="8" :xs="24" class="grande-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix subtitulo_calidad">
            <span>{{ $t('calidad.certificaciones.titulo') }}</span>
          </div>
          <el-carousel indicator-position="outside">
            <el-carousel-item v-for="(img, i) in images_second" :key="i" class="carousel-slide" style="background-color: white !important">
              <img class="foto" :src="img" alt="foto" />
            </el-carousel-item>
          </el-carousel>
        </el-card>
      </el-col>
      <el-col :md="8" :xs="24" class="grande-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix subtitulo_calidad">
            <span>{{ $t('calidad.bp.titulo') }}</span>
          </div>
          <el-carousel indicator-position="outside">
            <el-carousel-item v-for="(img, i) in images_t" :key="i" class="carousel-slide" style="background-color: white !important">
              <img class="foto" :src="img" alt="foto" />
            </el-carousel-item>
          </el-carousel>
        </el-card> </el-col
    ></el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      images: [
        require('@/assets/calidad/00_Habilitaciones - MINISTEIRO DE SALUD.png'),
        require('@/assets/calidad/00_Habilitaciones - INAL.jpg'),
        require('@/assets/calidad/00_Habilitaciones - ANMAT.jpg'),
      ],
      images_second: [
        require('@/assets/calidad/01_Certificaciones_ISO_2015.jpg'),
        require('@/assets/calidad/01_Certificaciones_ISO_2015_2.jpg'),
        require('@/assets/calidad/01_Certificaciones_ISO_2018.jpg'),
        require('@/assets/calidad/01_Certificaciones_ISO_2019.jpg'),
      ],
      images_t: [
        require('@/assets/calidad/GMP_2.jpg'),
        require('@/assets/calidad/GDP_2.jpg'),
        // require('@/assets/calidad/04_RESGUARDA.png'),
        // require('@/assets/calidad/ISO_2019.jpg'),
      ],
    }
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
    },
    goToSlide(i) {
      this.currentIndex = i
    },
  },
}
</script>
<style>
.card-wrapper,
.box-card {
  width: 100% !important;
}
.bg-nosotros-2 {
  padding: 4% 10% 4% 10%;
}
/* .grande {
  padding: 0px 10% 1% 10%;
} */
.grande-col {
  padding: 0px 3%;
  /* margin-right: -5%; */
  display: flex;
  justify-content: center;
}
.titulo_calidad {
  margin: 0 auto;
  text-align: center;
  position: relative;
  padding-bottom: 4%;
  /* font-size: 2.3rem; */
  font-size: 62px;
  color: #d35915;
  /* font-weight: 700; */
  letter-spacing: 2px;
  text-transform: uppercase;
  font-family: 'roboto-black';
  /* padding-bottom: 3%; */
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.subtitulo_calidad {
  /* font-size: 1.3rem !important; */
  font-size: 33px;
  color: #706f6e !important;
  /* font-weight: 700 !important; */
  text-align: center !important;
  margin: 0 auto !important;
  font-family: 'roboto-cursiva-black';
}

@media (min-width: 2561px) {
  .titulo_calidad {
    font-size: 65px;
  }
  .subtitulo_calidad {
    font-size: 34px;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .titulo_calidad {
    font-size: 62px;
  }
  .subtitulo_calidad {
    font-size: 34px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .titulo_calidad {
    font-size: 56px;
  }
  .subtitulo_calidad {
    font-size: 31px;
  }
  .foto {
    max-width: 60% !important;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .titulo_calidad {
    font-size: 50px;
  }
  .subtitulo_calidad {
    font-size: 27px;
  }
  .foto {
    max-width: 65% !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .subtitulo_calidad {
    font-size: 27px;
  }
  .titulo_calidad {
    font-size: 51px;
  }
  .subtitulo_calidad {
    font-size: 19;
  }
  .foto {
    max-width: 45% !important;
  }
}
@media (orientation: portrait) {
  @media screen and (min-width: 375px) and (max-width: 767px) {
    .foto {
      max-width: 60%;
      margin-bottom: 60px;
      margin-top: -20%;
    }
    .titulo_calidad {
      font-size: 35px;
      padding-bottom: 8%;
      /* margin-top: 10%; */
    }
    .subtitulo_calidad {
      font-size: 22px;
    }
    .grande-col {
      padding: 0px 10% 5% 10%;
    }
  }
  @media (max-width: 375px) {
    .foto {
      max-width: 70% !important;
      margin-bottom: 80px;
    }
    .titulo_calidad {
      font-size: 35px;
      padding-bottom: 8%;
      margin-top: 10%;
    }
    .subtitulo_calidad {
      font-size: 22px;
    }
    .grande-col {
      padding: 0px 10% 5% 10%;
    }
  }
}
/* HORIZONTAL */
@media (orientation: landscape) and (max-height: 500px) {
  .foto {
    max-width: 35% !important;
    margin-bottom: 20px !important;
    /* margin-top: -20% !important; */
  }
  .grande-col {
    padding: 3% 3%;
    /* margin-right: -5%; */
    display: flex;
    justify-content: center;
  }
}
</style>
<style scoped>
.box-card >>> .el-card__body {
  padding: 0 !important;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.box-card {
  width: 100% !important;
  height: 60vh;
}
@media (min-width: 2561px) {
  .box-card {
    width: 100% !important;
    height: 40vh;
  }
  .carousel-slide img {
    max-width: 60%;
    max-height: 40vh;
    object-fit: contain; /* mantiene proporciones reales */
    display: block;
    margin: 0 auto;
    border-radius: 8px;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .box-card {
    width: 95% !important;
    height: 40vh;
  }
  .carousel-slide img {
    max-width: 60%;
    max-height: 40vh;
    object-fit: contain; /* mantiene proporciones reales */
    display: block;
    margin: 0 auto;
    border-radius: 8px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .box-card {
    width: 95% !important;
    height: 42vh;
  }
  .carousel-slide img {
    max-width: 40%;
    max-height: 49vh;
    object-fit: contain; /* mantiene proporciones reales */
    display: block;
    margin: 0 auto;
    border-radius: 8px;
    margin-bottom: 10%;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .box-card {
    width: 95% !important;
    height: 50vh;
  }
  .carousel-slide img {
    max-width: 50%;
    max-height: 53vh;
    object-fit: contain; /* mantiene proporciones reales */
    display: block;
    margin: 0 auto;
    border-radius: 8px;
    margin-bottom: 20%;
  }
}

@media (orientation: landscape) {
  .box-card {
    width: 70%;
    height: 380px;
    min-height: 300px;
  }

  element.style {
    display: none;
  }

  .el-carousel__arrow {
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    height: 36px;
    width: 36px;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 50%;
    background-color: rgba(31, 45, 61, 0.11);
    color: #fff;
    position: absolute;
    top: 25%;
    z-index: 10;
    transform: translateY(-50%);
    text-align: center;
    font-size: 12px;
  }
}
@media (orientation: portrait) {
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    .box-card {
      width: 85% !important;
      height: 33vh;
      margin-bottom: 5%;
    }
  }

  @media screen and (min-width: 375px) and (max-width: 767px) {
    .box-card {
      width: 80% !important;
      height: 32vh;
      /* margin-bottom: 30px; */
    }
  }
  @media (max-width: 375px) {
    .box-card {
      width: 80% !important;
      height: 38vh;
      /* margin-bottom: 30px; */
    }
  }
}
.carousel-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-track {
  display: flex;
  transition: transform 0.8s ease-in-out;
}

.carousel-slide {
  min-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .carousel-slide img {
  max-width: 70%;
  max-height: 50vh;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
} */

/* Controles */
button.prev,
button.next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.4);
  color: white;
  border: none;
  font-size: 1rem;
  padding: 8px 14px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
}

button.prev:hover,
button.next:hover {
  background: rgba(0, 0, 0, 0.7);
}

button.prev {
  left: 20px;
}
button.next {
  right: 20px;
}

/* Indicadores */
.indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
}

.indicators span {
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s;
}
.indicators span.active {
  background: #fff;
}
</style>
